import React, { useEffect, useState } from 'react';
import { reportApi } from '../services/api';
import Brand from './Brand';
import HeaderNav from './HeaderNav';
import ResearchDisclaimer from './ResearchDisclaimer';
import { HUB_DESCRIPTIONS } from '../utils/hubDescriptions';

const list = (value) => (Array.isArray(value) ? value : []);
const isOpenScope = (scope) => scope && scope !== 'none' && scope !== 'locked';
const updatedLabel = (value) => {
  const date = new Date(value);
  return `${date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit' })} ${date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}`;
};

const HubsLanding = ({ user, publicMode = false, onBack, onLogout, onOpenProfile }) => {
  const [hubs, setHubs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError('');
      try {
        if (publicMode) {
          const catalog = await reportApi.publicPlans();
          setHubs(list(catalog.hubs).map((hub) => ({ ...hub, scope: hub.public || hub.scope || 'public' })));
        } else {
          const result = await reportApi.hubs();
          setHubs(list(result.hubs));
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [publicMode]);

  return (
    <div className="app-shell">
      <header className="topbar">
        <Brand href={publicMode ? '/plans' : '/'} onClick={(event) => { if (onBack && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) { event.preventDefault(); onBack(); } }} />
        <HeaderNav user={user} publicMode={publicMode} onWorkspace={onBack} onLogout={onLogout} onOpenProfile={onOpenProfile} />
      </header>
      <main className="workspace hub-workspace">
        <section className="workspace-intro">
          <div><p className="eyebrow">Cross-company intelligence</p><h1>Hubs.</h1></div>
          <p className="intro-copy">Market-wide pages for news, catalysts, ownership, and discovery.</p>
        </section>
        {error && <div className="error-box workspace-error" role="alert">{error}</div>}
        {loading ? <div className="empty-state">Loading hubs...</div> : (
          <div className="hub-card-grid">
            {hubs.map((hub) => {
              const scope = hub.scope || 'none';
              const open = isOpenScope(scope);
              return (
                <article className={`panel hub-tile ${open ? '' : 'locked'}`} key={hub.id}>
                  <div className="panel-heading"><div><p className="eyebrow">{open ? scope : 'Locked'}</p><h2>{hub.label || hub.id}</h2></div>{!open && <span className="hub-lock" aria-label="Locked">🔒</span>}</div>
                  {hub.employee_only && <span className="hub-badge">Employee only</span>}
                  {HUB_DESCRIPTIONS[hub.id] && <p className="muted">{HUB_DESCRIPTIONS[hub.id]}</p>}
                  {!open && <p className="muted">Upgrade to unlock this hub.</p>}
                  <div className="hub-tile-footer">
                    {hub.as_of && <time className="hub-tile-updated" dateTime={hub.as_of}>Updated {updatedLabel(hub.as_of)}</time>}
                    {open ? <a className="primary-button hub-tile-action" href={`/hubs/${encodeURIComponent(hub.id)}`}>Open hub</a> : <a className="secondary-button hub-tile-action" href="/plans">View plans</a>}
                  </div>
                </article>
              );
            })}
          </div>
        )}
        <ResearchDisclaimer />
      </main>
    </div>
  );
};

export default HubsLanding;
